var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRightSmallMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75011 13.4C5.52011 13.4 5.29011 13.31 5.11011 13.14C4.94218 12.9713 4.8479 12.743 4.8479 12.505C4.8479 12.267 4.94218 12.0387 5.11011 11.87L8.98011 8L5.11011 4.14C4.94218 3.97133 4.8479 3.74301 4.8479 3.505C4.8479 3.26699 4.94218 3.03867 5.11011 2.87C5.27878 2.70207 5.5071 2.60779 5.74511 2.60779C5.98312 2.60779 6.21144 2.70207 6.38011 2.87L10.8801 7.37C11.048 7.53867 11.1423 7.76699 11.1423 8.005C11.1423 8.24301 11.048 8.47133 10.8801 8.64L6.38011 13.14C6.21011 13.31 5.98011 13.4 5.75011 13.4Z",
    fill: "#989BA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightSmallMono);
export default __webpack_public_path__ + "static/media/icon-arrow-right-small-mono.f06c6b34fbad7a245af0243014628eab.svg";
export { ForwardRef as ReactComponent };